import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  appBar: {
    top: 'auto',
    bottom: 0,
    height: 'auto',
    padding: '16px',
    /* ensure content doesn't overlap system/home indicator on mobile */
    paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
    boxSizing: 'border-box',
    background: theme.color.greys[0],
    borderTop: `1px solid ${theme.color.greys[15]}`,
    zIndex: 1,
    '& .MuiToolbar-root': {
      width: '100%',
      maxWidth: theme.space.basicDataMaxWidth,
      margin: '0 auto',
    },
  },
  container: {
    maxWidth: theme.space.basicDataMaxWidth,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 16,
    },
  },
  nextButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  spacer: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  quantityWrapper: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    width: 210,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  quantityTitle: {
    marginBottom: 4,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
}), { name: 'CartQuantityBar' });
